import { render } from "./master-data-list.vue?vue&type=template&id=194f8f88&scoped=true"
import script from "./master-data-list.vue?vue&type=script&lang=js"
export * from "./master-data-list.vue?vue&type=script&lang=js"

import "./master-data-list.vue?vue&type=style&index=0&id=194f8f88&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194f8f88"]])

export default __exports__